import React from 'react';
import styled from 'styled-components';
import IDHelpers from '../../../../core/helpers/IDHelper';
import { SingleDayWeek } from './SingleDayWeek';

const DaysWeekWrap = styled.div`
  margin-bottom: 8px;
`;

function DaysWeek(props: any) {
  const { days } = props;
  return (
    <DaysWeekWrap>
      {days &&
        days.map((day: any) => (
          <SingleDayWeek key={IDHelpers.generateID()} value={day} />
        ))}
    </DaysWeekWrap>
  );
}

export default DaysWeek;
